import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Pagination } from '../../models/pagination/pagination.model';
import { BaseService } from '../../templates/services/base-service.template';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class MerchantBankService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/merchant-bank-account';

  constructor(protected readonly http: HttpClient) {}

  public create(data: any,  { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
  
  public update(data: any,  { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.put(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public getByCriteria(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.get(`${ api_domain_url }${ this.apiUrl }/backoffice-ep/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
